import { TrendingUp } from '@mui/icons-material'
import { Avatar, Card, CardContent, CardHeader, LinearProgress } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { Suspense, useEffect } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { CustomDatePickerField } from '../CustomDatePickerField'
import { CoinSymbolToName } from '../util/CoinUtil'
import { dayjsToQueryVariable, useDayjsDate } from '../util/DateUtils'
import { TopLosersPageContent } from './TopLosersPageContent'
import { useCoin } from '../coin/CoinContainer'

function TopLosersPage() {
  const { date } = useParams()
  const dayJsDate = useDayjsDate(date)
  const navigate = useNavigate()
  const coin = useCoin()
  useEffect(() => {
    const oldTitle = document.title
    document.title = `${CoinSymbolToName[coin.toUpperCase()]} Top Gainers`
    return () => {
      document.title = oldTitle
    }
  }, [coin])
  return (
    <Card>
      <CardHeader
        avatar={
          <Avatar>
            <TrendingUp />
          </Avatar>
        }
        title="Top Gainers"
        subheader={
          <DatePicker
            slots={{ field: CustomDatePickerField }}
            value={dayJsDate}
            minDate={dayjs('2009-01-09')} //First bitcoin block
            maxDate={dayjs().add(-1, 'day')}
            onChange={(newValue) => {
              if (newValue)
                navigate(
                  generatePath('/:coin/top-losers/:date', {
                    coin,
                    date: dayjsToQueryVariable(newValue)
                  })
                )
            }}
          />
        }
      />
      <CardContent>
        <Suspense
          fallback={<LinearProgress sx={{ width: '30%', maxWidth: 160, mx: 'auto', my: 5 }} />}
        >
          <TopLosersPageContent />
        </Suspense>
      </CardContent>
    </Card>
  )
}

export default TopLosersPage
